export var MuiAlert = {
  styleOverrides: {
    standard: {
      ".MuiAlert-message": {
        padding: 0
      },
      ".MuiAlert-icon": {
        padding: 0
      },
      padding: 0
    },
    outlined: function outlined(_ref) {
      var theme = _ref.theme;
      return {
        borderRadius: theme.spacing(1),
        "& .MuiAlert-icon": {
          display: 'flex',
          alignItems: 'center'
        }
      };
    },
    standardError: function standardError(_ref2) {
      var theme = _ref2.theme;
      return {
        color: theme.palette.error.main,
        backgroundColor: 'transparent'
      };
    },
    filledError: function filledError(_ref3) {
      var theme = _ref3.theme;
      return {
        color: theme.palette.error.main,
        backgroundColor: theme.palette.error.light
      };
    },
    standardSuccess: function standardSuccess(_ref4) {
      var theme = _ref4.theme;
      return {
        color: theme.palette.success.main,
        backgroundColor: 'transparent'
      };
    },
    filledSuccess: function filledSuccess(_ref5) {
      var theme = _ref5.theme;
      return {
        color: theme.palette.success.main,
        backgroundColor: theme.palette.success.light
      };
    },
    outlinedSuccess: function outlinedSuccess(_ref6) {
      var theme = _ref6.theme;
      return {
        color: theme.palette.success.main,
        backgroundColor: theme.palette.success.light,
        borderColor: theme.palette.success.main
      };
    }
  }
};
//# sourceMappingURL=MuiAlert.js.map